import { render, staticRenderFns } from "./vehicle-selector.vue?vue&type=template&id=5d3407a6&"
import script from "./vehicle-selector.vue?vue&type=script&lang=js&"
export * from "./vehicle-selector.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports